import React, { useMemo, useState } from "react";
import AddUserAccessManagement from "../../library/AddUserAccessManagement/AddUserAccessManagement";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  addUserAccessManagementReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./AddUserAccessManagement.store";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { RegistrationType } from "../../library/AddUserAccessManagement/AddUserAccessManagement.constants.js";
import { useEffect } from "react";

export const SmartAddUserAccessManagement = (props) => {
  const {
    studies,
    roles,
    sites,
    registrationType,
    selectedUser,
    onClose,
    inviteAdminUser,
    updateAdminUser,
    updateUserData,
    mainColor,
    fetchSites,
    checkIfEmailExists,
    emailExists,
    resetEmailExists,
  } = props;

  const [submitting, setSubmitting] = useState(false);

  const sitesFormatted = useMemo(
    () => sites?.map((site) => ({ id: site.key, value: site.name })),
    [sites]
  );

  const onSubmit = ({ id, email, roleName, study, sites }) => {
    setSubmitting(true);

    if (registrationType === RegistrationType.Admin) {
      if (selectedUser) {
        updateAdmin(id, email, roleName, study, sites);
      } else {
        createAdmin(email, roleName, study, sites);
      }
    } else {
      updateParticipant(id, study);
    }
  };

  const updateAdmin = (id, username, roleName, study, sites) => {
    updateAdminUser(id, username, roleName, study, sites)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const createAdmin = (email, roleName, study, sites) => {
    inviteAdminUser(email, roleName, study, sites)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const updateParticipant = (id, study) => {
    updateUserData(id, study)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    return () => resetEmailExists();
  }, [resetEmailExists]);

  return (
    <AddUserAccessManagement
      onSubmit={onSubmit}
      registrationType={registrationType}
      selectedUser={selectedUser}
      studies={studies}
      roles={roles}
      mainColor={mainColor}
      sites={sitesFormatted}
      fetchSites={fetchSites}
      submitting={submitting}
      emailExists={emailExists}
      resetEmailExists={resetEmailExists}
      onValidateEmail={checkIfEmailExists}
    />
  );
};

export default dynamic(
  "addUserAccessManagementReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(addUserAccessManagementReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartAddUserAccessManagement));
